import { useMemo } from "react";
import { useQuery } from "react-query";
import { getcountryList } from "../utils/queries";

export const useGetCountry = (enabled = true) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["get-country"],
    queryFn: async () => await getcountryList(),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  });

  const options = useMemo(() => {
    const countries = data?.data || [];
    return countries.map(({ countryName, countryCodeAlpha2 }) => ({
      value: countryName,
      label: `${countryName} | ${countryCodeAlpha2}`,
      code: countryCodeAlpha2,
    }));
  }, [data]);

  return { options, isLoading, isError, rawData: data?.data || [] };
};

export default useGetCountry;
